<template>
  <div class="subscription-management padding-bottom-xl">
    <riseup-header
      color-variant="green"
      :logo-color="'white'"
    />
    <dashboard-page :image-header-props="imageHeaderProps">
      <template v-slot:header>
        <div class="header">
          <img
            v-if="fromAppValue === 'true'"
            :src="leftArrow"
            class="margin-bottom-m"
            @click="backToApp"
          >
          <div class="title ri-glbl-large-display">
            Subscription Details
          </div>
        </div>
      </template>
      <template v-slot:dashboard>
        <subscription-information />
      </template>
      <button-footer
        class="margin-top-m"
        :button-text="buttonText"
        :color="'beige'"
        :action="buttonAction"
      />
    </dashboard-page>
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router';
import DashboardPage from '@riseupil/base-ui/src/templates/DashboardPage.vue';
import RiseupHeader from '../Common/RiseupHeader.vue';
import management from '../../assets/management.svg';
import leftArrow from '../../assets/left-arrow.svg';
import SubscriptionInformation from './SubscriptionInformation.vue';
import ButtonFooter from '../Common/ButtonFooter.vue';
import Segment from '../../Segment';
import { useSubscriptionStore } from '../../stores/subscription';

Segment.trackUserGot('SubscriptionManagementEntered');
const subscriptionStore = useSubscriptionStore();
const { subscription } = subscriptionStore;
const shouldDisplayResubscribe = subscriptionStore.isCancelled && subscription?.productId;

const buttonText = shouldDisplayResubscribe ? 'Renew Subscription' : 'Manage Subscription';
const fromApp = useRouteQuery<string>('fromApp');
const fromAppValue = fromApp.value;
const goToManagementPortal = async () => {
  Segment.trackUserInteraction('SubscriptionManagementClicked', { subscription });
  const portalUrl = await subscriptionStore.createManagementPortal(fromAppValue);
  window.location.href = portalUrl;
};

const goToCheckout = async () => {
  Segment.trackUserInteraction('RenewSubscriptionClicked', { subscription });
  if (!subscription?.productId) {
    throw new Error('unknown previous productId');
  }
  const portalUrl = await subscriptionStore.createCheckoutUrl(fromAppValue, subscription.productId);
  window.location.href = portalUrl;
};

const buttonAction = shouldDisplayResubscribe ? goToCheckout : goToManagementPortal;

const backToApp = async () => {
  window.location.href = 'riseup://subscription/subscription_finished';
};
const imageHeaderProps = {
  // eslint-disable-next-line global-require
  backgroundColor: 'dark-green',
  imgHeight: 330,
  imgSrc: management,
  bottomSeparator: false,
  backgroundPosition: 'bottom',
};

</script>
<style scoped lang="scss">
@import '@riseupil/base-ui/src/scss/riseup-colors';
.subscription-management {
  background-color: #FCF7ED;
  .header {
    margin-top: -120px;
    text-align: start;
    img {
      cursor: pointer;
    }
    .title {
      text-align: start;
      display: block;
    }
    .bottom-filler {
      margin-bottom: 100px;
    }
  }
}

</style>
